import { c as _c } from "react/compiler-runtime";
import { BoatIcon } from '@navikt/aksel-icons';
import { ExpansionCard, HStack } from '@navikt/ds-react';
import Knappenavn from './Knappenavn';
import styles from './Seksjon.module.css';
import { store } from '@/app/_components/store/store';
import SeksjonsListe, { SeksjonsFelt } from '@/components/seksjons-liste';
import SortedTable from '@/components/sorted-table';
import { Utenlandsopphold } from 'types/arbeidsforhold';
import { formatDateMonth, formatDatePeriode } from 'utils/formatting/dato';
interface Props {
  data?: Array<Utenlandsopphold> | null;
}
const ArbeidIUtlandet = props => {
  const $ = _c(34);
  const texts = store.useReducerState().tekst;
  let t0;
  if ($[0] !== texts._locale) {
    t0 = value => formatDateMonth(value.rapporteringsmaaned, texts._locale);
    $[0] = texts._locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0 || $[3] !== texts.hjelpetekst.utenlandsopphold.rapporteringsmaaned || $[4] !== texts.utenlandsopphold.rapporteringsmaaned) {
    t1 = {
      label: texts.utenlandsopphold.rapporteringsmaaned,
      hjelpetekst: texts.hjelpetekst.utenlandsopphold.rapporteringsmaaned,
      getValue: t0,
      sortValue: _temp
    };
    $[2] = t0;
    $[3] = texts.hjelpetekst.utenlandsopphold.rapporteringsmaaned;
    $[4] = texts.utenlandsopphold.rapporteringsmaaned;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== texts.hjelpetekst.utenlandsopphold.opptjeningsperiode || $[7] !== texts.utenlandsopphold.opptjeningsperiode) {
    t2 = {
      label: texts.utenlandsopphold.opptjeningsperiode,
      hjelpetekst: texts.hjelpetekst.utenlandsopphold.opptjeningsperiode,
      minWidth: 160,
      getValue: _temp2
    };
    $[6] = texts.hjelpetekst.utenlandsopphold.opptjeningsperiode;
    $[7] = texts.utenlandsopphold.opptjeningsperiode;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== texts.hjelpetekst.utenlandsopphold.land || $[10] !== texts.utenlandsopphold.land) {
    t3 = {
      label: texts.utenlandsopphold.land,
      hjelpetekst: texts.hjelpetekst.utenlandsopphold.land,
      getValue: _temp3
    };
    $[9] = texts.hjelpetekst.utenlandsopphold.land;
    $[10] = texts.utenlandsopphold.land;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t4 = [t1, t2, t3];
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const felter = t4;
  let t5;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div><BoatIcon aria-hidden={true} className={styles.ikon} /></div>;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== texts.utenlandsopphold.utenlandsopphold) {
    t6 = <ExpansionCard.Header><HStack wrap={false} gap="space-16" align="center" className={styles.header}>{t5}<div><ExpansionCard.Title>{texts.utenlandsopphold.utenlandsopphold}</ExpansionCard.Title></div></HStack></ExpansionCard.Header>;
    $[17] = texts.utenlandsopphold.utenlandsopphold;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t6 || $[20] !== texts.utenlandsopphold.utenlandsopphold) {
    t7 = <Knappenavn navn={texts.utenlandsopphold.utenlandsopphold}>{t6}</Knappenavn>;
    $[19] = t6;
    $[20] = texts.utenlandsopphold.utenlandsopphold;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== felter || $[23] !== props.data || $[24] !== texts.filter || $[25] !== texts.utenlandsopphold.ingenTreff || $[26] !== texts.utenlandsopphold.rapporteringsmaaned) {
    t8 = props.data == null ? texts.filter.ikkeValgt : props.data?.length === 0 ? texts.utenlandsopphold.ingenTreff : <><div className={styles.kunBred}><SortedTable simple={true} sortable={false} itemsToShow={3} initialData={props.data || []} orderBy={texts.utenlandsopphold.rapporteringsmaaned} direction="descending" fields={felter} /></div><div className={styles.kunSmal}><SeksjonsListe data={props.data || []} felter={felter} noekkel={0} itemsToShow={3} /></div></>;
    $[22] = felter;
    $[23] = props.data;
    $[24] = texts.filter;
    $[25] = texts.utenlandsopphold.ingenTreff;
    $[26] = texts.utenlandsopphold.rapporteringsmaaned;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t8) {
    t9 = <ExpansionCard.Content className={styles.innhold}>{t8}</ExpansionCard.Content>;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t7 || $[31] !== t9 || $[32] !== texts.utenlandsopphold.utenlandsopphold) {
    t10 = <ExpansionCard aria-label={texts.utenlandsopphold.utenlandsopphold} defaultOpen={true} className={styles.kort}>{t7}{t9}</ExpansionCard>;
    $[30] = t7;
    $[31] = t9;
    $[32] = texts.utenlandsopphold.utenlandsopphold;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  return t10;
};
export default ArbeidIUtlandet;
function _temp(value_0) {
  return value_0.rapporteringsmaaned;
}
function _temp2(value_1) {
  return formatDatePeriode(value_1.startdato, value_1.sluttdato);
}
function _temp3(value_2) {
  return value_2.land.beskrivelse;
}